import { isMobile, $ } from '../utils/Utils';

const drawing = (() => {
  const config = {
    element: [...$('.js-drawing')],
    community: {
      characters: {
        grandma: '#drawing-p1',
        mama: '#drawing-p2',
        guy: '#drawing-p3',
        girl: '#drawing-p4',
        lady: '#drawing-p5',
        couple: '#drawing-p6',
      },
    },
  };

  const getDepth = (obj) => {
    const newObj = Object.entries(obj).map(([, value]) => {
      const item = document.querySelector(value);
      const { depth } = item.dataset;
      return { node: item, depth };
    });

    return newObj;
  };

  const handleParallax = (canvas) => {
    let wW = window.innerWidth;

    canvas.addEventListener('mousemove', (e) => {
      const pX = e.pageX;
      const pY = e.clientY;

      getDepth(config.community.characters).forEach((element) => {
        const x = (pX - (wW / 2)) / (-1000 / element.depth);
        let y = (element.depth * -500) / pY;
        const $element = element.node;
        y = (y < -30) ? -30 : y;
        $element.style.transform = `translate(${x}px, ${y}px)`;
      });
    });

    window.addEventListener('resize', () => {
      // update values
      wW = window.innerWidth;
    });
  };

  const setup = () => {
    config.element.forEach((element) => {
      handleParallax(element);
    });
  };

  const init = () => {
    if (
      // allow only on desktop
      !isMobile()
      // run only if element is present
      && config.element.length > 0
      // run on any browser except IE
      && !(navigator.userAgent.indexOf('MSIE') > -1 || navigator.appVersion.indexOf('Trident/') > -1)
    ) {
      setup();
    }
  };

  return {
    init,
  };
})();

export default drawing.init();
